import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { REDUX_STORAGE_KEY } from 'constants/index';

import settings from './settings';
import api from './api';
import ui from './ui';
import user from './user';

const combinedReducer = combineReducers({
  settings,
  ui,
  user,
  [api.reducerPath]: api.reducer,
});

const raw = typeof document !== 'undefined' ? document.getElementById(REDUX_STORAGE_KEY)?.textContent || '{}' : '{}';
const preloadedState = JSON.parse(raw);

export const makeStore = () =>
  configureStore({
    reducer: ((state, action) => {
      if (action.type === 'HYDRATE') {
        return { ...state, ...action.payload };
      } else {
        return combinedReducer(state, action);
      }
    }) as typeof combinedReducer,
    preloadedState,
    middleware: (gDM) =>
      gDM({
        serializableCheck: {
          ignoredActions: [],
          ignoredPaths: [],
        },
      }).concat(api.middleware),
  });

export const store = makeStore();
export const reducer = combinedReducer;

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = AppStore['dispatch'];
